<template>
  <div class="mdc-text-field-wrapper">
    <label class="mdc-text-field mdc-text-field--outlined" :class="{ 'mdc-text-field--focused': isFocused, 'mdc-text-field--invalid': !isValid }">
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>

        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" :class="{ 'mdc-floating-label--float-above': isFocused || modelValue }">
            {{ label }}
          </span>
        </span>

        <span class="mdc-notched-outline__trailing"></span>
      </span>

      <input
        ref="input"
        type="text"
        class="mdc-text-field__input"
        v-mask="'##.##.####'"
        :value="modelValue"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        placeholder=""
      />
    </label>

    <div class="mdc-text-field-helper-line">
      <div
        class="mdc-text-field-helper-text"
        :class="{ 'mdc-text-field-helper-text--persistent': true, 'mdc-text-field-helper-text--validation-msg': !isValid }"
      >
        <span v-if="!isValid">Некорректная дата</span>
        <span v-else-if="isFocused">дд.мм.гггг</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mask } from 'vue-the-mask';

export default {
  name: 'DateField',
  directives: { mask },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Дата рождения*',
    },
  },
  emits: ['update:modelValue', 'valid'],
  data() {
    return {
      isFocused: false,
      isValid: true,
    };
  },
  methods: {
    validate(value) {
      if (!value) return false;
      const m = moment(value, 'DD.MM.YYYY', true);
      const valid = m.isValid() && m.isBefore(moment());
      this.isValid = valid;
      this.$emit('valid', valid);
      return valid;
    },
    onInput(e) {
      const val = e.target.value;
      this.$emit('update:modelValue', val);
      if (val.length === 10) {
        this.validate(val);
      } else {
        this.isValid = true;
      }
    },
    onFocus() {
      this.isFocused = true;
    },
    onBlur() {
      this.isFocused = false;
      if (this.modelValue.length === 10) {
        this.validate(this.modelValue);
      }
    },
  },
};
</script>

<style>
.mdc-text-field-wrapper {
  width: auto;
}
.mdc-text-field {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 56px;
}
.mdc-text-field__input {
  width: 100%;
  border: none;
  outline: none;
  padding: 20px 12px 6px;
  font-size: 16px;
  background: transparent;
}
.mdc-notched-outline {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  pointer-events: none;
}
.mdc-notched-outline__leading,
.mdc-notched-outline__trailing {
  border: 1px solid #9e9e9e;
  width: 12px;
}
.mdc-notched-outline__notch {
  border-top: 1px solid #9e9e9e;
  border-bottom: 1px solid #9e9e9e;
  flex: 1;
  position: relative;
}
.mdc-text-field--focused .mdc-notched-outline__leading,
.mdc-text-field--focused .mdc-notched-outline__trailing,
.mdc-text-field--focused .mdc-notched-outline__notch {
  border-color: #1976d2;
}
.mdc-text-field--invalid .mdc-notched-outline__leading,
.mdc-text-field--invalid .mdc-notched-outline__trailing,
.mdc-text-field--invalid .mdc-notched-outline__notch {
  border-color: #d32f2f;
}
.mdc-floating-label {
  position: absolute;
  left: 12px;
  top: 18px;
  font-size: 16px;
  color: #9e9e9e;
  transition: all 0.2s ease;
  background: white;
  padding: 0 4px;
}
.mdc-floating-label--float-above {
  top: -8px;
  font-size: 12px;
  color: #1976d2;
}
.mdc-text-field--invalid .mdc-floating-label--float-above {
  color: #d32f2f;
}
.mdc-text-field-helper-line {
  min-height: 20px;
  margin-top: 4px;
}
.mdc-text-field-helper-text {
  font-size: 12px;
  color: #9e9e9e;
}
.mdc-text-field-helper-text--validation-msg {
  color: #d32f2f;
}
</style>
